import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { SUPPORTED_LANGUAGES } from '../constants/languages';
import type { SupportedLanguage } from '../types/language';

export const useTranslation = (namespace?: string | string[]) => {
  const { t, i18n } = useI18nTranslation(namespace);

  const changeLanguage = useCallback(async (lng: SupportedLanguage) => {
    if (SUPPORTED_LANGUAGES.includes(lng)) {
      try {
        await i18n.changeLanguage(lng);
        document.documentElement.lang = lng;
        document.documentElement.dir = i18n.dir();
        Cookies.set('i18next', lng, { expires: 365 });
      } catch (error) {
        console.error('Error changing language:', error);
      }
    }
  }, [i18n]);

  return {
    t,
    i18n,
    currentLanguage: i18n.language as SupportedLanguage,
    changeLanguage,
    isRTL: i18n.dir() === 'rtl'
  };
};